import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataOverrideDTO} from '../models/DataOverrideDTO';

@Injectable({
  providedIn: 'root'
})
export class DataOverrideService {
  private url = environment.baseUrl + '/data-override';

  constructor(private httpClient: HttpClient) { }

  saveOverride(dataOverrideDTO: DataOverrideDTO): Observable<DataOverrideDTO> {
    return this.httpClient.post<DataOverrideDTO>(this.url, dataOverrideDTO);
  }

}
